import { useCallback, useEffect, useState } from 'react'
import { login } from '../shared/api'
import { tg } from '../shared/lib/telegram'
import { CalendarIcon, PlusIcon, TagIcon } from '../shared/ui/Icons'
import { ItemsList, NewItemForm } from '../items'
import { ScheduleList } from '../schedule'
import type { User } from '../shared/types'
import './App.css'

type Tab = 'schedule' | 'items' | 'new'

const TABS: [Tab, string, () => JSX.Element][] = [
  ['schedule', 'Расписание', CalendarIcon],
  ['items', 'Товары', TagIcon],
  ['new', 'Новый', PlusIcon],
]

const TITLES: Record<Tab, string> = {
  schedule: 'Расписание',
  items: 'Товары',
  new: 'Новый товар',
}

export default function App() {
  const [user, setUser] = useState<User | null>(null)
  const [denied, setDenied] = useState<string | null>(null)
  const [tab, setTab] = useState<Tab>('schedule')
  // Счётчик вместо флага: любая правка увеличивает его, и списки перечитываются.
  const [version, setVersion] = useState(0)
  const refresh = useCallback(() => setVersion((v) => v + 1), [])

  useEffect(() => {
    login()
      .then(setUser)
      .catch((e: Error) => setDenied(e.message))
  }, [])

  if (denied) {
    return (
      <div className="app">
        <div className="gate">
          <h2>Вход закрыт</h2>
          <p>{denied}</p>
        </div>
      </div>
    )
  }
  if (!user) {
    return (
      <div className="app">
        <div className="head">
          <div className="brand">Akramov Shop</div>
          <h1>Входим…</h1>
        </div>
        <div className="skeleton" />
        <div className="skeleton" />
      </div>
    )
  }

  return (
    <div className="app">
      <header className="head">
        <div className="brand">Akramov Shop</div>
        <h1>{TITLES[tab]}</h1>
        <div className="who">
          {user.first_name || user.username || user.id}
          {user.role === 'owner' ? ' · владелец' : ' · менеджер'}
        </div>
      </header>

      {tab === 'schedule' && <ScheduleList version={version} refresh={refresh} />}
      {tab === 'items' && (
        <ItemsList version={version} refresh={refresh} onSchedule={() => setTab('schedule')} />
      )}
      {tab === 'new' && (
        <NewItemForm
          onDone={() => {
            refresh()
            setTab('items')
          }}
        />
      )}

      <nav className="tabs">
        {TABS.map(([key, label, IconTag]) => (
          <button
            key={key}
            className={tab === key ? 'on' : ''}
            onClick={() => {
              tg?.HapticFeedback?.selectionChanged()
              setTab(key)
            }}
          >
            <IconTag />
            {label}
          </button>
        ))}
      </nav>
    </div>
  )
}
